import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminBlogList from "./pages/admin/AdminBlogList";
import Login from "./pages/admin/Login";
import BlogCreate from "./pages/admin/BlogCreate";
import BlogEdit from "./pages/admin/BlogEdit";
import BlogIndividual from "./pages/public/BlogIndividual";
import Home from "./pages/public/Home";
import About from "./pages/public/About";
import Blog from "./pages/public/Blog";
import Contact from "./pages/public/Contact";
import PrivacyPolicy from "./pages/public/PrivacyPolicy";
import Tutorials from "./pages/public/Tutorials";
import Header from "./pages/layout/Header";
import Footer from "./pages/layout/Footer";

export const App = () => {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
       
        <Route path="/" element={ <><Header /> <Home /> <Footer /></>} />
        <Route path="/about" element={<><Header /> <About /> <Footer /></>} />
        <Route path="/blog" element={<><Header /> <Blog /> <Footer /></>} />
        <Route path="/blog/:id" element={<><Header /> <BlogIndividual /> <Footer /></>} />
        <Route path="/contact" element={<><Header /> <Contact /> <Footer /></>} />
        <Route path="/tutorials" element={<><Header /> <Tutorials /> <Footer /></>} />
        <Route path="/privacy-policy.html" element={<><Header /> <PrivacyPolicy /> <Footer /></>} />

        <Route path="/admin/login" element={<Login />} />

        {/* Admin protected routes */}
        <Route
          path="/admin/blogs"
          element={
            <ProtectedRoute>
              <AdminBlogList />
            </ProtectedRoute>
          }
        />
        <Route
        path="/admin/blogs/add"
        element={
          <ProtectedRoute>
            <BlogCreate />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/blogs/edit/:id"
        element={
          <ProtectedRoute>
            <BlogEdit />
          </ProtectedRoute>
        }/>
      </Routes>
    </Router>
  );
};

export default App;